export const getCampaignsList = async (smasiInstance, collectionId) => {
  try {
    let envVar =
      smasiInstance === "ceres"
        ? process.env.REACT_APP_SMASI_CONFIG
        : process.env.REACT_APP_SMASI_CONFIG_MARS;

    envVar = envVar.replace(/\\"/g, '"');
    const smasiConfig = JSON.parse(envVar);

    const response = await fetch(
      `https://${smasiConfig.hostname}/api/v3/config/Campaign/list?collectionId=${collectionId}`,
      {
        method: "GET",
        headers: {
          Authorization: `${smasiConfig.apikey}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

export const getActionsList = async (
  smasiInstance,
  collectionId,
  campaignId
) => {
  try {
    let envVar =
      smasiInstance === "ceres"
        ? process.env.REACT_APP_SMASI_CONFIG
        : process.env.REACT_APP_SMASI_CONFIG_MARS;

    envVar = envVar.replace(/\\"/g, '"');
    const smasiConfig = JSON.parse(envVar);

    const response = await fetch(
      `https://${smasiConfig.hostname}/api/v2/config/action/list?collectionId=${collectionId}&campaignId=${campaignId}`,
      {
        method: "GET",
        headers: {
          Authorization: `${smasiConfig.apikey}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

export const getActionConfig = async (smasiInstance, actionId) => {
  try {
    let envVar =
      smasiInstance === "ceres"
        ? process.env.REACT_APP_SMASI_CONFIG
        : process.env.REACT_APP_SMASI_CONFIG_MARS;

    envVar = envVar.replace(/\\"/g, '"');
    const smasiConfig = JSON.parse(envVar);

    const response = await fetch(
      `https://${smasiConfig.hostname}/api/v4/config/action?actionId=${actionId}`,
      {
        method: "GET",
        headers: {
          Authorization: `${smasiConfig.apikey}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

export const getProductsCatalog = async (smasiInstance, brandId) => {
  try {
    let envVar =
      smasiInstance === "ceres"
        ? process.env.REACT_APP_SMASI_CONFIG
        : process.env.REACT_APP_SMASI_CONFIG_MARS;

    envVar = envVar.replace(/\\"/g, '"');
    const smasiConfig = JSON.parse(envVar);

    const response = await fetch(
      `https://${smasiConfig.hostname}/api/v2/Config/Product/List?brandId=${brandId}`,
      {
        method: "GET",
        headers: {
          Authorization: `${smasiConfig.apikey}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

export const getLinkCatalogsList = async (smasiInstance, collectionId) => {
  try {
    let envVar =
      smasiInstance === "ceres"
        ? process.env.REACT_APP_SMASI_CONFIG
        : process.env.REACT_APP_SMASI_CONFIG_MARS;

    envVar = envVar.replace(/\\"/g, '"');
    const smasiConfig = JSON.parse(envVar);

    const response = await fetch(
      `https://${smasiConfig.hostname}/api/v3/config/linkCatalog/list?collectionId=${collectionId}`,
      {
        method: "GET",
        headers: {
          Authorization: `${smasiConfig.apikey}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

export const getTemplateTypes = async (smasiInstance, organizationId) => {
  try {
    let envVar =
      smasiInstance === "ceres"
        ? process.env.REACT_APP_SMASI_CONFIG
        : process.env.REACT_APP_SMASI_CONFIG_MARS;

    envVar = envVar.replace(/\\"/g, '"');
    const smasiConfig = JSON.parse(envVar);

    const response = await fetch(
      `https://${smasiConfig.hostname}/api/v2/config/templateType/list?organizationId=${organizationId}`,
      {
        method: "GET",
        headers: {
          Authorization: `${smasiConfig.apikey}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};
